import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../state";

export const createAdditionalPoles = createAsyncThunk('createAdditionalPoles', async (data: any) => {
    try {
        const response = await axios({
            method: 'post',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/additionalpoles',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const deleteAdditionalPoles = createAsyncThunk('deleteAdditionalPoles', async (id: string) => {
    try {
        const response = await axios({
            method: 'delete',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/additionalpoles?id=' + id,
        })
        return response
    } catch (error: any) {
        return error.response
    }
})

export const editAdditionalPoles = createAsyncThunk('editAdditionalPoles', async (data: any) => {
    try {
        const response = await axios({
            method: 'put',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('cqmToken')
            },
            url: baseUrl + '/additionalpoles',
            data: data
        })
        return response
    } catch (error: any) {
        return error.response
    }
})